import { Button } from 'foundations-components/transitional/components/Button';
import { connect } from 'react-redux';
// @ts-expect-error types missing
import { convertForm } from 'FormsUI/actions/CollectedForms';
// @ts-expect-error types missing
import { getRequestState } from 'FormsUI/selectors/CollectedForms';
import { hasFormsWriteAccess as hasFormsWriteAccessFromSelector } from 'FormsUI/selectors/Scope';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
// @ts-expect-error types missing
import withPermissionsTooltip from 'FormsCommonComponents/withPermissionsTooltip';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import H2 from 'UIComponents/elements/headings/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PermissionedUIButton = withPermissionsTooltip(Button);
const ConvertCollectedFormDialog = ({
  guid,
  currentFolderId,
  onClose,
  requestState,
  hasFormsWriteAccess,
  disabled = false,
  convert
}) => {
  const handleConvertCollectedForm = () => {
    trackDashboardInteraction('convert-collected-form');
    convert(guid, currentFolderId);
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    "data-test-id": "convert-form-dialog",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: () => onClose()
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'collectedFormConverter.dialog.header'
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'collectedFormConverter.dialog.body'
        })
      })
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsx(PermissionedUIButton, {
        use: "primary",
        disabled: disabled || requestState.isPending(),
        onClick: handleConvertCollectedForm,
        hasPermission: hasFormsWriteAccess,
        "data-test-id": "confirm-convert-collected-form",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'collectedFormConverter.dialog.confirm'
        })
      })
    })]
  });
};
const mapStateToProps = state => ({
  requestState: getRequestState(state),
  hasFormsWriteAccess: hasFormsWriteAccessFromSelector(state)
});
const actionsToBind = {
  convert: convertForm
};
export default connect(mapStateToProps, actionsToBind)(ConvertCollectedFormDialog);